import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import './app.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

// Das MUI-Theme liegt NICHT hier, sondern in der nachgeladenen Layout-Route `ThemedOutlet`
// (App.tsx) -- sonst gehörte MUI wieder zum ersten Paket, auch für das Kiosk-Tablet.
createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
